'use client'

import { useEffect } from 'react'
import { useRouter } from 'next/navigation'

interface DocStaticRedirectProps {
  href: string
}

/**
 * Client-side redirect for static export (`output: 'export'`), where
 * `next/navigation` `redirect()` and `next.config` redirects are unavailable
 * for MDX-derived wrapper section URLs.
 */
export function DocStaticRedirect({ href }: DocStaticRedirectProps) {
  const router = useRouter()

  useEffect(() => {
    router.replace(href)
  }, [href, router])

  return (
    <>
      <meta httpEquiv="refresh" content={`0;url=${href}`} />
      <p className="text-sm text-slate-600 dark:text-slate-400">
        Redirecting to{' '}
        <a
          href={href}
          className="text-blue-600 underline hover:text-blue-500 dark:text-blue-400"
        >
          {href}
        </a>
        …
      </p>
    </>
  )
}
